import angular from 'angular';
import editableText from './editableText';

export default angular
  .module('components.editableText', [])
  .component('editableText', editableText).name;
